// AIUploadSection.js
import React, { useState } from 'react';

const AIUploadSection = ({ onImagesChange, images, onDimensionsChange, dimensions }) => {
  const handleImagesChange = (event) => {
    const files = Array.from(event.target.files);
    onImagesChange(files);
  };

  const handleImagesDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const files = Array.from(event.dataTransfer.files).filter(file => file.type.startsWith('image/'));
    onImagesChange(files);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const removeImage = (indexToRemove) => {
    const updatedImages = images.filter((_, index) => index !== indexToRemove);
    onImagesChange(updatedImages);
  };

  const handleHeightChange = (e) => {
    const height = parseFloat(e.target.value) || 0;
    onDimensionsChange({ ...dimensions, height });
  };

  const handleUnitChange = (e) => {
    const unit = e.target.value;
    onDimensionsChange({ ...dimensions, unit });
  };

  return (
    <>
      {/* Images Upload Section */}
      <div style={{ marginBottom: '20px' }}>
      <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#333' }}>
        Images for 3D Generation (1-4 images)
      </label>
      <div
        onDrop={handleImagesDrop}
        onDragOver={handleDragOver}
        style={{
          border: '2px dashed #ccc',
          padding: '25px',
          textAlign: 'center',
          borderRadius: '4px',
          backgroundColor: 'white',
          minHeight: '120px',
        }}
      >
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImagesChange}
          style={{ display: 'none' }}
          id="images-upload"
        />
        <label htmlFor="images-upload" style={{ cursor: 'pointer', display: 'block' }}>
          <span className="material-icons" style={{ fontSize: '24px', color: '#666' }}>collections</span>
          <span style={{ display: 'block', marginBottom: '5px', color: '#000' }}>Upload Images</span>
          <span style={{ color: '#666' }}>
            {images.length > 0 ? `${images.length} image(s) selected` : 'Drag & drop or click to browse (1-4 images)'}
          </span>
        </label>
      </div>
      
      {/* Show selected images */}
      {images.length > 0 && (
        <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {images.map((image, index) => (
            <div key={index} style={{ position: 'relative' }}>
              <img
                src={URL.createObjectURL(image)}
                alt={`Preview ${index + 1}`}
                style={{
                  width: '60px',
                  height: '60px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              />
              <button
                onClick={() => removeImage(index)}
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  backgroundColor: '#ff4444',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* Dimensions Section */}
    <div style={{ marginBottom: '40px' }}>
      <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', color: '#333' }}>
        Dimensions (Optional)
      </label>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '3px' }}>
            Height
          </label>
          <input
            type="number"
            placeholder="0.5"
            value={dimensions.height || ''}
            onChange={handleHeightChange}
            step="0.01"
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              fontSize: '14px',
              boxSizing: 'border-box',
            }}
          />
        </div>
        <div style={{ width: '100px' }}>
          <label style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '3px' }}>
            Unit
          </label>
          <select
            value={dimensions.unit || 'meters'}
            onChange={handleUnitChange}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              fontSize: '14px',
              boxSizing: 'border-box',
            }}
          >
            <option value="meters">meters</option>
            <option value="cm">cm</option>
            <option value="mm">mm</option>
            <option value="inches">inches</option>
            <option value="feet">feet</option>
          </select>
        </div>
      </div>
      <p style={{ fontSize: '12px', color: '#666', marginTop: '5px', marginBottom: '0' }}>
        Width and depth will scale proportionally to maintain realistic proportions
      </p>
    </div>
    </>
  );
};

export default AIUploadSection;